module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/invoices/invoice-update/invoice-client-info/invoice-client-info.scss
// module id = ./web/modern/components/invoices/invoice-update/invoice-client-info/invoice-client-info.scss
// module chunks = 0